import React from "react";
import { Pagination as MuiPagination, Stack, Button } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { mainButtonStyles } from "../Styles/Styles";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (event, page) => {
    window.scrollTo(0, 0); // Scroll to top on page change
    onPageChange(page);
  };

  return (
    <Stack
      spacing={2}
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        mt: 4,
        mb: 4,
      }}
    >
      <Button
        className="previous-button-style"
        disabled={currentPage === 1}
        onClick={() => {
          if (currentPage > 1) {
            window.scrollTo(0, 0); // Scroll to top on "Previous" click
            onPageChange(currentPage - 1);
          }
        }}
        sx={{ ...mainButtonStyles }}
      >
        <span>
          <ArrowBackOutlinedIcon />
        </span>
        <span>Previous</span>
      </Button>

      <MuiPagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        shape="rounded"
        hidePrevButton
        hideNextButton
        siblingCount={0}
        boundaryCount={1}
        sx={{
          "& .MuiPaginationItem-root": {
            color: "var(--primary-color)", // Color for all unselected items
            "&.Mui-selected": {
              backgroundColor: "var(--primary-color)", // Background for selected page
              color: "white", // Text color for selected page
              "&:hover": {
                backgroundColor: "var(--primary-color)", // Keep primary color on hover for selected
              },
            },
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.08)", // Hover effect for unselected items
            },
            "&:focus, &:active": { outline: "none" }, // Remove outline for focus/active states
          },
        }}
      />
      <Button
        className="main-button-style"
        onClick={() => {
          if (currentPage < totalPages) {
            window.scrollTo(0, 0); // Scroll to top on "Next" click
            onPageChange(currentPage + 1);
          }
        }}
        disabled={currentPage === totalPages}
        sx={{ ...mainButtonStyles }}
      >
        <span>Next</span>
        <span>
          <ArrowForwardOutlinedIcon />
        </span>
      </Button>
    </Stack>
  );
};

export default Pagination;
